/***
 * 创建人：李珊
 * 时间：2020-11-27
 * 描述: 素材导入控制台：提供素材导入入口、统计素材数量
 * 使用说明:
 * 更新说明:
 */
import { Component, OnInit } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../kms.service';
import { InstanceModuleService } from '../../serves/instance/instance.module';
declare var $;
@Component({
  selector: 'app-material-console',
  templateUrl: './material-console.component.html',
  styleUrls: ['./material-console.component.css']
})
export class MaterialConsoleComponent implements OnInit {
  materialInfo:any = [];
  chartOptions1:any;
  chartOptions2:any;
  chartOptions3:any;
  chartOptions4:any;
  echarts:any;

  constructor(
    private instanceModuleService: InstanceModuleService,
    private kmsService: KmsService,
    private box: SwMassageBoxService,
  ) {
    this.getChart1();
    this.getChart2();
    this.getChart3();
    // this.getChart4();
  }

  ngOnInit() {
  }

  // 根据素材类型进行统计
  getChart1(){
    // 资源类型数据
    let fileCategoryOptions = this.instanceModuleService.getResourceTypeOptions();
    this.kmsService.statisticMaterial({}).subscribe(
      data => {
        if(data.code == '200'){
          let res = data.data ? data.data : [];
          if(res.length > 0){
            res.forEach(item => {
              let arr = fileCategoryOptions.filter(el => el.id == item.name);
              item['name'] = arr.length>0 ? arr[0].text : '';
              item['value'] = item.total;
            })
            // 按照素材数量降序排列
            res = res.sort(function (a, b) { return b.value - a.value });
            let xData=[];
            let yData=[];
            for(let i=0;i<res.length;i++){
                xData.push(res[i].name);
                yData.push(res[i].value);
            }
            this.chartOptions1={
              color: '#5B8FF9',
              tooltip: {
                trigger: 'axis',
                formatter: '{a} <br/>{b} : {c}',
                axisPointer: {
                  type: 'shadow'
                }
              },
              xAxis: {
                type: 'category',
                data: xData,
                axisLabel: {
                  // 更改x轴文字颜色的配置
                  textStyle: {
                    color: '#888888 ',
                  }
                },
                // 更改x轴线的颜色
                axisLine: {
                  lineStyle: {
                    color: '#dedede',
                  }
                }
              },
              yAxis: {
                type: 'value',
                axisLabel: {
                  // 更改y轴文字颜色的配置
                  textStyle: {
                    color: '#888888 ',
                  }
                },
                // 更改y轴线的颜色
                axisLine: {
                  lineStyle: {
                    color: '#dedede',
                  }
                }
              },
              series: [
                {
                  name:'素材数量',
                  data: yData,
                  type: 'bar',
                  barWidth: 20,
                }
              ],
              grid: {
                top: 10,
                left: 10,
                bottom: 10,
                right: 10,
                containLabel: true
              }
            };
            let height = $('#chartBox').height();
            $('#chart1').css('height', height);
          }
        }else{
          console.log('根据素材类型进行统计查询失败！');
        }
      }
    );
  }

  // 根据素材获取方式进行统计
  getChart2(){
    const accessTypes = [
      {id:1,text:'文件导入'},
      {id:2,text:'网络抓取'},
      {id:3,text:'人工录入'},
    ]
    this.kmsService.statisticMaterialByAccessType({}).subscribe(
      data => {
        if(data.code == '200'){
          let res = data.data ? data.data : [];
          if(res.length > 0){
            res.forEach(item => {
              let arr = accessTypes.filter(el => el.id == item.name);
              item['name'] = arr.length>0 ? arr[0].text : '';
              item['value'] = item.total;
            })
            // 按照素材数量降序排列
            res = res.sort(function (a, b) { return b.value - a.value });
            this.chartOptions2 = {
              color: ['#5B8FF9','#FAC858','#91CC75'],
              tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c}'
              },
              legend: {
                type: 'scroll',
                orient: 'vertical',
                right: 5,
                top: 5,
                bottom: 5,
                itemWidth: 10,
                itemHeight: 10,
                icon: 'circle',
                itemGap: 12
              },
              series: [
                {
                  name: '素材数量',
                  type: 'pie',
                  radius: ['50%', '85%'],   // 第一个参数：内圆半径；第二个参数：外圆半径
                  center: ['40%', '48%'],   // 第一个参数：左中右位置，越大越靠右；第二个参数：上中下位置，越大越靠下；
                  avoidLabelOverlap: false,
                  label: {
                    show: true,
                    position: 'inside'
                  },
                  labelLine: {
                    length: 10,
                    lineStyle: {
                      width: 1,
                      type: 'solid'
                    }
                  },
                  itemStyle: {
                    borderColor: '#fff',
                    borderWidth: 1
                  },
                  emphasis: {
                    label: {
                      fontSize: 20
                    }
                  },
                  data: res
                }
              ]
            };
            let height = $('#chartBox').height() - 20;
            $('#chart2').css('height', height);
          }
        }else{
          console.log('根据素材类型进行统计查询失败！');
        }
      }
    );
  }

  // 根据是否提取文字进行统计
  getChart3(){
    this.kmsService.statisticMaterialByExtractStatus({}).subscribe(
      data => {
        if(data.code == '200'){
          let res = data.data ? data.data : [];
          if(res.length > 0){
            res.forEach(item => {
              item['value'] = item.total;
            })
            this.chartOptions3 = {
              color: ['#5B8FF9','#91CC75'],
              tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c}'
              },
              legend: {
                data: ['未提取文字', '已提取文字'],
                type: 'scroll',
                orient: 'vertical',
                right: 5,
                top: 5,
                bottom: 5,
                itemWidth: 10,
                itemHeight: 10,
                icon: 'circle',
                itemGap: 12
              },
              series: [
                {
                  name: '素材数量',
                  type: 'funnel',
                  left: '20%',
                  top: 20,
                  bottom: 10,
                  width: '60%',
                  min: 0,
                  max: 100,
                  minSize: '0%',
                  maxSize: '100%',
                  sort: 'descending',
                  gap: 2,
                  label: {
                    show: true,
                    position: 'inside'
                  },
                  labelLine: {
                    length: 10,
                    lineStyle: {
                      width: 1,
                      type: 'solid'
                    }
                  },
                  itemStyle: {
                    borderColor: '#fff',
                    borderWidth: 1
                  },
                  emphasis: {
                    label: {
                      fontSize: 20
                    }
                  },
                  data: res
                }
              ]
            };
            let height = $('#chartBox').height() - 20;
            $('#chart3').css('height', height);
          }
        }else{
          console.log('根据素材类型进行统计查询失败！');
        }
      }
    );
  }

  // 根据提取知识实体数量进行统计
  getChart4(){
    this.kmsService.statisticMaterialByInstanceCount({}).subscribe(
      data => {
        if(data.code == '200'){
          let res = data.data ? data.data : [];
          // if(res.length > 0){
          //   res.forEach(item => {
          //     item['value'] = item.total;
          //   })
          // }else{
          //   return;
          // }
          setTimeout(()=>{
            let res =[
              {name:'《天工开物》1',value:145},{name:'《天工开物》2',value:345},{name:'《天工开物》3',value:25},
              {name:'《天工开物》4',value:245},{name:'《天工开物》5',value:15},{name:'《天工开物》6',value:85},
              {name:'《天工开物》7',value:45},{name:'《天工开物》8',value:55},{name:'《天工开物》9',value:45},
              {name:'《天工开物》10',value:45}
            ]
            // 按照素材数量升序排列
            res = res.sort(function (a, b) { return a.value - b.value });
            let xData=[];
            let yData=[];
            for(let i=0;i<res.length;i++){
                xData.push(res[i].name);
                yData.push(res[i].value);
            }
            this.chartOptions4={
              color: '#5B8FF9',
              tooltip: {
                trigger: 'axis',
                formatter: '{a} <br/>{b} : {c}',
                axisPointer: {
                  type: 'shadow'
                }
              },
              yAxis: {
                type: 'category',
                data: xData,
                axisLabel: {
                  // 更改x轴文字颜色的配置
                  textStyle: {
                    color: '#888888 ',
                  }
                },
                // 更改x轴线的颜色
                axisLine: {
                  lineStyle: {
                    color: '#dedede',
                  }
                }
              },
              xAxis: {
                type: 'value',
                axisLabel: {
                  // 更改y轴文字颜色的配置
                  textStyle: {
                    color: '#888888 ',
                  }
                },
                // 更改y轴线的颜色
                axisLine: {
                  lineStyle: {
                    color: '#dedede',
                  }
                }
              },
              series: [
                {
                  name:'素材数量',
                  data: yData,
                  type: 'bar',
                  barWidth: 15,
                }
              ],
              grid: {
                top: 10,
                left: 10,
                bottom: 10,
                right: 10,
                containLabel: true
              }
            };
            let height = $('#chartBox').height();
            $('#chart4').css('height', height);
          },500)
        }else{
          console.log('根据素材类型进行统计查询失败！');
        }
      }
    );
  }
}
